import "./style.scss";
import LinkButton from "../common/linkButton";
import React from "react";
import GenericTable from "../common/genericTable";
import {MESSAGES} from "../../constants";
import Button from "../common/button";

const columns = [
  {name: 'name', label: 'School'},
  {name: 'permissionLevel', label: 'Permission Level'}
];

const UserPermissions = (props) => {

  const {
    userProfile,
    goToPermissionEditAction,
    hideEditButton,
    districts
  } = props;


  const formatCell = (item, column) => {
    switch (column.name) {
      case 'permissionLevel':
        return userProfile.permission.name;
      case 'school-with-district':
        const district = districts.find((district) => district.id === item.districtId);

        return (district) ? `${district.name} - ${item.name}` : item.name;
      default:
        return item[column['name']];
    }
  }

  function prepareColumns () {
    return columns.map((column) => {

      switch (column.name) {
        case 'name':
          if (userProfile) {
            switch (userProfile.permission.authority) {
              case 'ROLE_PERMISSION_SUPER_USER':
              case 'ROLE_PERMISSION_ADMIN':
                column.label = 'District';
                return column;
              case 'ROLE_PERMISSION_BATCH':
                column.label = (userProfile.districtList && userProfile.districtList.length > 0 && userProfile.districtList[0].id) ? 'District' : 'District - School';
                if (userProfile.schoolList && userProfile.schoolList.length > 0 && userProfile.schoolList[0].id) {
                  column.onDisplay = (item, column) => {
                    return formatCell(item, {name: 'school-with-district'});
                  }
                }
                return column;
              default:
                column.label = 'District - School';

                column.onDisplay = (item, column) => {
                  return formatCell(item, {name: 'school-with-district'});
                }

                return column;
            }
          }
          return column;
        case 'permissionLevel':
          column.onDisplay = (item, column) => {
            return formatCell(item, column);
          };
          return column;
        default:
          return column;
      }
    });
  }

  function getItems () {
    if (userProfile) {
      switch (userProfile.permission.authority) {
        case 'ROLE_PERMISSION_ADMIN':
          return userProfile.districtList;
        case 'ROLE_PERMISSION_BATCH':
          return (userProfile.districtList && userProfile.districtList[0].id) ? userProfile.districtList : userProfile.schoolList;
        case 'ROLE_PERMISSION_COORDINATOR':
        case 'ROLE_PERMISSION_VIEWER':
          return userProfile.schoolList;
        default:
          break;
      }
    }

    return [];
  }

  const emptyMessage = (userProfile && userProfile.permission.authority === 'ROLE_PERMISSION_SUPER_USER') ? MESSAGES.USERS.superUserPermissions : MESSAGES.USERS.noUserPermissions;

  return (
    <div className='user-permissions'>
      <div className='user-permissions-header'>
        <div className='user-permissions-title'>
          Permissions
        </div>
        <div className='user-profile-buttons'>
          {!hideEditButton && <Button label='Edit' action={goToPermissionEditAction}/>}
        </div>
      </div>
      <div className='user-permissions-body'>
        <GenericTable tableData={getItems()} cols={prepareColumns(columns)} emptyMessage={emptyMessage} sortAction={null}/>
      </div>
    </div>
  );
}

export default UserPermissions;